"use client";

import type React from "react";
import { FieldContainer } from "./FieldContainer";
import { FieldLabel } from "./FieldLabel";
import { fieldErrorClassname, fieldInputVariants } from "./field-variants";
import { useFieldContext } from "../hooks/form-context";

export interface BaseFieldProps {
  label: string;
  placeholder?: string;
  required?: boolean;
  name: string;
}

export interface InputProps extends BaseFieldProps {
  type?: "text" | "email";
  showTestVariant?: boolean;
}

export const Input = ({ label, placeholder, required, name, type = "text", showTestVariant }: InputProps) => {
  const field = useFieldContext();

  return (
    <FieldContainer>
      <FieldLabel label={label} htmlFor={name} required={required} showTestVariant={showTestVariant} />
      <input
        className={fieldInputVariants()}
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        required={required}
        value={field.state.value as string}
        onChange={e => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        autoComplete='off'
      />
      {!field.state.meta.isValid && field.state.meta.isBlurred && field.state.meta.errors.length > 0 && (
        <div className={fieldErrorClassname} role='alert'>
          {field.state.meta.errors[0]}
        </div>
      )}
    </FieldContainer>
  );
};

export const FieldText = (props: Omit<InputProps, "type">) => {
  return <Input {...props} type='text' />;
};

export const FieldEmail = (props: Omit<InputProps, "type">) => {
  return <Input {...props} type='email' />;
};
